import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'displayNameCustomBold',
    standalone: false
})
export class DisplayNameCustomBoldPipe implements PipeTransform {

  transform(displayName: string): string {
    if (displayName.includes("Overtime")) {
      return '<strong>Overtime</strong>' + displayName.replace("Overtime", "");
    } else if (displayName.includes("Meal break")) {
      return '<strong>Meal break</strong>' + displayName.replace("Meal break", "");
    } else {
      return '<strong>' + displayName + '</strong>'
    }
  }

}
